$('#billing_cep').mask('00000-000');

function frete_produto(){

    var postalCode = $('.product-shipping #billing_cep').val();
    var productId = $('form .product-variant-id').val(); // Substitua pelo ID da variante do produto
    var quantity = 1; // Defina a quantidade desejada

    $('.result-container .cep-value').text(postalCode);
    
    // Mostra animação inicial de carregamento
    $('.loading').slideDown();
    $('.result-container').hide();

    if (postalCode === '') {
        $('.loading').fadeOut();
        $('.result-container').hide();
        return;
    }
    
    $('.product-shipping').addClass('waiting');

    // Consultar o ViaCEP para obter o estado
    $.ajax({
        url: `https://viacep.com.br/ws/${postalCode}/json/`,
        type: 'GET',
        dataType: 'json',
        success: function(data) {
            if (data.erro) {
                $('.result-container').hide();
                return;
            }

            var state = data.uf; // Obtém o estado a partir da resposta do ViaCEP

            // Primeiro, adicionar o produto ao carrinho
            $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                dataType: 'json',
                data: {
                    id: productId,
                    quantity: quantity
                },
                success: function() {
                    // Após adicionar ao carrinho, calcular o frete
                    $.ajax({
                        url: '/cart/shipping_rates.json',
                        type: 'GET',
                        data: {
                            'shipping_address[zip]': postalCode,
                            'shipping_address[country]': 'BR', // ou outro país
                            'shipping_address[province]': state // Estado obtido via ViaCEP
                        },
                        success: function(data) {
                            var rates = data.shipping_rates;
                            var resultHtml = '';

                            if (rates.length > 0) {

                                $.each(rates, function(index, rate) {
                                    resultHtml += '<div class="shipping"> <div class="shipping-info"> <span class="rate-name">' + rate.name + ':</span> <span class="rate-days">'+rate.delivery_days[0]+' dias úteis</span> </div> R$ ' + rate.price +  '</div>';
                                });

                            } else {
                                resultHtml = '<p>Não foi possível calcular o frete.</p>';
                                $('.product-shipping').removeClass('waiting');
                            }
                            
                            $('.product-shipping .input-part').slideUp(200);
                            $('.loading').slideUp(200);
                            
                            setTimeout(() => {
                                $('.product-shipping .results').html(resultHtml);
                                $('.result-container').slideDown();
                            }, 500);
                            

                            // Remover o produto do carrinho
                            $.ajax({
                                url: '/cart/change.js',
                                type: 'POST',
                                dataType: 'json',
                                data: {
                                    id: productId,
                                    quantity: 0
                                },
                                success: function() {
                                    console.log('Produto removido do carrinho.');
                                },
                            });
                        }
                    });
                }
            });
        }
    });
}

$('.cep-toggle').on('click', (e) => {
    e.preventDefault();
    $('.product-shipping .result-container').slideUp(200);
    
    setTimeout( function(){
        $('.product-shipping .input-part').slideDown();
    }, 500);

});